import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';

export const buildAggregateSpecialMetricQuery = (
  metrics: MetricInput[],
  expressions: Expression2[],
  filterInput: FilterInput[],
  dateScope: DateRangeInput,
  queryName: string,
  trendByCalendarInterval?: FleetOps.Interval,
  trendByFiscalInterval?: FiscalInterval,
) => {
  return {
    query: gql`
      query ${queryName}(
        $metrics: [MetricInput]!
        $filters: [FilterInput]!
        $dateScope: [DateRangeInput!]!
        $expressions: [Expression2]!
        $trendByCalendarInterval: Interval
        $trendByFiscalInterval: FiscalInterval
      ) {
        ${queryName}(
          metrics: $metrics
          filters: $filters
          dateScope: $dateScope
          expressions: $expressions
          trendByCalendarInterval: $trendByCalendarInterval
          trendByFiscalInterval: $trendByFiscalInterval
        )
      }
    `,
    variables: {
      metrics,
      filters: filterInput,
      dateScope,
      expressions,
      trendByCalendarInterval,
      trendByFiscalInterval,
    },
  };
};

const aggregateSpecialMetrics = async ({
  client,
  filterInput,
  dateScope,
  trendByCalendarInterval,
  trendByFiscalInterval,
  queryName,
}: {
  client: ApolloClient<NormalizedCacheObject>;
  filterInput: FilterInput[];
  dateScope: DateRangeInput;
  trendByCalendarInterval?: FleetOps.Interval;
  trendByFiscalInterval?: FiscalInterval;
  queryName: string;
}): Promise<MetricResponse[]> => {
  const metrics = [] as MetricInput[];
  const expressions = [] as Expression2[];
  const query = buildAggregateSpecialMetricQuery(
    metrics,
    expressions,
    filterInput,
    dateScope,
    queryName,
    trendByCalendarInterval,
    trendByFiscalInterval,
  );

  const response = await client.query(query);
  return response.data[queryName];
};

export default aggregateSpecialMetrics;
